import Axios from "axios";

const BASE_URL = `${import.meta.env.VITE_BASE_URL_API_BACKEND}/metrics`;

export default class metricService {
  static get = async (params) => {
    try {
      const { data } = await Axios.get(BASE_URL, { params });
      return data;
    } catch (error) {
      console.error("Erro /metrics:", error);
      throw error;
    }
  };

  static getById = async (id) => {
    try {
      const { data } = await Axios.get(`${BASE_URL}/${id}`);
      return data;
    } catch (error) {
      console.error(`Erro /metrics/${id}:`, error);
      throw error;
    }
  };

  static post = async (payload) => {
    try {
      const { data } = await Axios.post(BASE_URL, payload);
      return data;
    } catch (error) {
      console.error("Erro POST /metrics:", error);
      throw error;
    }
  };

  static put = async (id, payload) => {
    try {
      const { data } = await Axios.put(`${BASE_URL}/${id}`, payload);
      return data;
    } catch (error) {
      console.error(`Erro PUT /metrics/${id}:`, error);
      throw error;
    }
  };

  static delete = async (id) => {
    try {
      await Axios.delete(`${BASE_URL}/${id}`);
      return true;
    } catch (error) {
      console.error(`Erro DELETE /metrics/${id}:`, error);
      throw error;
    }
  };
}
